import { File, Identifiable, Resource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";
import { getPrivateDocuments } from "../documents/getPrivateDocuments";
import { saveDocument } from "../documents/saveDocument";
import { getCurrentPlanzone } from "./getCurrentPlanzone";

function saveProfilePicture(
  apiHttpClient: HttpClient,
  docHttpClient: HttpClient,
) {
  return (resource: Identifiable<Resource>, profilePicture: File) =>
    getCurrentPlanzone(apiHttpClient)().then((planzone) =>
      getPrivateDocuments(docHttpClient)(planzone.uuid, "planzone")
        .then((rootDocument) =>
          saveDocument(docHttpClient)(
            planzone.uuid,
            "planzone",
            rootDocument,
            profilePicture,
          ),
        )
        .then((document) =>
          apiHttpClient
            .sendHttpRequest<void>({
              endpoint: `/resources/${resource.uuid}`,
              method: HttpMethods.PATCH,
              data: {
                avatarUrl: document.uuid,
              },
            })
            .then(() => document),
        ),
    );
}

export { saveProfilePicture };
